module.exports=function(scope){ return `{
    "meta": {
        "ok": true,
        "code": 200,
        "mode": "dev",
        "message": "The search request was processed successfully."
    },
    "data": {
        "results": [
            {
                "enrollmentIdentifier": "foo",
                "matchLevel": "10",
                "auditTrailImage": "..."
            },
            {
                "enrollmentIdentifier": "bar",
                "matchLevel": "10",
                "auditTrailImage": ""
            }
        ],
        "sourceFaceMap": {
            "isReplayFaceMap": false
        }
    }
}

<!-- NOTE: Server REST API provides additional properties for this end point. -->
`};


// WEBPACK FOOTER //
// ./src/resources/code/webservice-v2/response/success/search.json.tpl